import i18n from '@/i18n/index.js'
import { translateImportFailReason } from '@/utils/importFailReasonI18n.js'

const API_MESSAGE_I18N_KEYS = {
  IOT编号不得超2000字符: 'apiMessage.name1',
  iot未入库: 'apiMessage.name2',
  'iot未入库!': 'apiMessage.name3',
  'iot编号已经存在!': 'apiMessage.name4',
  'mac地址已经存在!': 'apiMessage.name5',
  '你只有3次分享的机会!': 'apiMessage.name6',
  '你好，获取验证码失败。该电动自行车已被其他用户绑定!': 'apiMessage.name7',
  '你无权修改!': 'apiMessage.name8',
  '你无权修改该车辆!': 'apiMessage.name9',
  '你无权删除该车辆!': 'apiMessage.name10',
  '你无权删除该骑行记录!': 'apiMessage.name11',
  '你无权去修改!': 'apiMessage.name12',
  '你无权去操作!': 'apiMessage.name13',
  '你无权去操作该路书!': 'apiMessage.name14',
  '你无权操作该路书!': 'apiMessage.name15',
  '你无权操作该车辆!': 'apiMessage.name16',
  '你无权查看！': 'apiMessage.name17',
  '你无权访问该车辆!': 'apiMessage.name18',
  '你无权访问该车辆！': 'apiMessage.name19',
  '你无权访问车辆!': 'apiMessage.name20',
  '你无法访问该车辆！': 'apiMessage.name21',
  '你无该车辆！': 'apiMessage.name22',
  '你没有权限操作该车辆!': 'apiMessage.name23',
  '信息修改失败！': 'apiMessage.name24',
  '共享授权ID为空！': 'apiMessage.name25',
  '共享授权不存在！': 'apiMessage.name26',
  '共享验证无效，无法禁用！': 'apiMessage.name27',
  '删除共享授权失败！': 'apiMessage.name28',
  '历史骑行记录不能为空!': 'apiMessage.name29',
  '反馈信息不存在!': 'apiMessage.name30',
  '反馈状态设置不正确！': 'apiMessage.name31',
  '取消防盗超时!': 'apiMessage.name32',
  '围栏并不存在！': 'apiMessage.name33',
  '围栏根本不存在！': 'apiMessage.name34',
  '围栏点不能为空！': 'apiMessage.name35',
  '围栏车辆不存在！': 'apiMessage.name36',
  '围栏车辆已经存在！': 'apiMessage.name37',
  '固件不存在！': 'apiMessage.name38',
  '固件信息不存在!': 'apiMessage.name39',
  '头部错误!': 'apiMessage.name40',
  '存在子菜单，不可删除': 'apiMessage.name41',
  '存在角色和菜单绑定，不可删除': 'apiMessage.name42',
  '密码必须包含数字，大小写字母和特殊符号且长度大于8位': 'apiMessage.name43',
  '已有重复数据!': 'apiMessage.name44',
  '开启防盗超时!': 'apiMessage.name45',
  '微信小程序获取授权信息失败！': 'apiMessage.name46',
  '您不能朝着该车辆!': 'apiMessage.name47',
  '您无权查看骑行轨迹!': 'apiMessage.name48',
  '您无法进入该车辆！': 'apiMessage.name49',
  '您无法进入车辆!': 'apiMessage.name50',
  '报头错误！': 'apiMessage.name51',
  按钮类型的权限表示不能为空: 'apiMessage.name52',
  '数据异常!': 'apiMessage.name53',
  整车编号已存在: 'apiMessage.name54',
  '文件名称过长！': 'apiMessage.name55',
  '无操作权限！': 'apiMessage.name56',
  '无权修改此围栏！': 'apiMessage.name57',
  '无权删除此围栏！': 'apiMessage.name58',
  '无权访问!': 'apiMessage.name59',
  '无权访问！': 'apiMessage.name60',
  无此操作权限: 'apiMessage.name61',
  '无法获取绑定信息。您输入的电话号码与预设电话号码不匹配!': 'apiMessage.name62',
  '未找到分页数据!': 'apiMessage.name63',
  '未检测到Excel数据！': 'apiMessage.name64',
  '权限不足！': 'apiMessage.name65',
  '标题错误！': 'apiMessage.name66',
  '此版本号已存在，请重新填写！': 'apiMessage.name67',
  '用户车辆不存在！': 'apiMessage.name68',
  '用户骑行不存在！': 'apiMessage.name69',
  '电动自行车已经存在!': 'apiMessage.name70',
  '短信注册今日已达上限，请明日再试!': 'apiMessage.name71',
  '禁用共享验证失败！': 'apiMessage.name72',
  '租户不存在！': 'apiMessage.name73',
  '租户信息不存在!': 'apiMessage.name74',
  '系统异常!': 'apiMessage.name75',
  系统菜单id不能为空: 'apiMessage.name76',
  系统菜单不存在: 'apiMessage.name77',
  '获取微信小程序用户信息失败！': 'apiMessage.name78',
  '获取微信小程序用户手机号失败！': 'apiMessage.name79',
  菜单类型的组件路径不能为空: 'apiMessage.name80',
  '表头错误！': 'apiMessage.name81',
  角色名称重复: 'apiMessage.name82',
  '解锁超时!': 'apiMessage.name83',
  '该围栏不存在！': 'apiMessage.name84',
  '该忽略请求不存在，无法忽略!': 'apiMessage.name85',
  '该联系人不存在！': 'apiMessage.name86',
  '该联系人已经存在！': 'apiMessage.name87',
  该账号并未绑定手机号: 'apiMessage.name88',
  '该路书不存在!': 'apiMessage.name89',
  '该车型不存在!': 'apiMessage.name90',
  '该车辆不存在!': 'apiMessage.name91',
  '该车辆不存在，请确认!': 'apiMessage.name92',
  '该车辆不属于你！': 'apiMessage.name93',
  '该车辆已经存在!': 'apiMessage.name94',
  '该车辆当前正在被使用!': 'apiMessage.name95',
  '该车辆当前正在被锁定，请稍后再试试!': 'apiMessage.name96',
  '该车辆正在被使用!': 'apiMessage.name97',
  '该车辆编号不能为空!': 'apiMessage.name98',
  '请先输入车型信息！': 'apiMessage.name99',
  '请填写设置信息!': 'apiMessage.name100',
  '请正确输入参数!': 'apiMessage.name101',
  '请选择一辆车！': 'apiMessage.name102',
  '请选择厂商！': 'apiMessage.name103',
  '请选择并输入维修信息！': 'apiMessage.name104',
  '读取EXCEL失败，请检查文件格式是否异常!': 'apiMessage.name105',
  '读取EXCEL失败，请检查文件格式是否异常！': 'apiMessage.name106',
  '调用查询流量接口失败！': 'apiMessage.name107',
  '该SIM卡在运营商平台不存在！': 'apiMessage.name150',
  '查询流量数据解析失败！': 'apiMessage.name151',
  '路书不存在!': 'apiMessage.name108',
  '车型不存在!': 'apiMessage.name109',
  '车型不存在！': 'apiMessage.name110',
  '车型信息不存在！': 'apiMessage.name111',
  '车型编号已存在!': 'apiMessage.name112',
  '车辆不在线!': 'apiMessage.name113',
  '车辆不存在!': 'apiMessage.name114',
  '车辆不存在！': 'apiMessage.name115',
  '车辆不存在，请确认!': 'apiMessage.name116',
  '车辆信息不存在!': 'apiMessage.name117',
  '车辆信息不存在！': 'apiMessage.name118',
  '车辆信息已存在!': 'apiMessage.name119',
  '车辆信息已存在！': 'apiMessage.name120',
  '车辆关锁超时!': 'apiMessage.name121',
  '车辆已经被其他人绑定!': 'apiMessage.name122',
  '车辆未找到!': 'apiMessage.name123',
  '车辆编号不存在！': 'apiMessage.name124',
  '车辆编号不能为空！': 'apiMessage.name125',
  '车辆调试报告不存在！': 'apiMessage.name126',
  '返回的用户不存在!': 'apiMessage.name127',
  '进入运输模式超时！': 'apiMessage.name128',
  '问题不存在!': 'apiMessage.name129',
  '问题反馈不存在！': 'apiMessage.name130',
  '骑行编号不正确!': 'apiMessage.name131',
  '骑行编号不能为空!': 'apiMessage.name132',
  操作成功: 'apiMessage.name133',
  操作失败: 'apiMessage.name134',
  参数不正确: 'apiMessage.name135',
  参数检验失败: 'apiMessage.name136',
  '未登录或token过期，请登录！': 'apiMessage.name137',
  '用户缓存已过期，请清除缓存重新登录': 'apiMessage.name138',
  没有相关权限: 'apiMessage.name139',
  没有找到相关数据: 'apiMessage.name140',
  系统异常: 'apiMessage.name141',
  SQL异常: 'apiMessage.name142',
  'Header error!': 'apiMessage.name143',
  'Excel data not detected!': 'apiMessage.name144',
  'The uploaded file object does not exist ..': 'apiMessage.name145',
  'File directory creation failed ..': 'apiMessage.name146',
  'Target file creation failed ..': 'apiMessage.name147',
  'file does not exist': 'apiMessage.name148',
  // —— 以下为后端 fail()/BusinessException() 历史未覆盖文案，补齐 i18n 映射 ——
  '下载临时文件失败！': 'apiMessage.name152',
  无权访问该车辆数据: 'apiMessage.name153',
  '未经授权访问！': 'apiMessage.name154',
  '请选择一个制造商！': 'apiMessage.name155',
  '车牌号码不能为空！': 'apiMessage.name156',
}

export function translateApiMessage (message) {
  if (!message || typeof message !== 'string') return message
  const trimmed = message.trim()
  const key = API_MESSAGE_I18N_KEYS[trimmed]
  if (key) return i18n.t(key)
  return translateImportFailReason(message)
}
